import { Component, OnDestroy, OnInit } from '@angular/core'
import { StateService } from '../../services/state.service'
import { LoaderService } from '../../services/loader.service'
import { NgIf } from '@angular/common'
import { TranslateModule } from '@ngx-translate/core'
import { combineLatest, Subscription } from 'rxjs'
import { environment } from '../../environments/environment'

@Component({
  selector: 'app-loader',
  standalone: true,
  imports: [NgIf, TranslateModule],
  templateUrl: './loader.component.html',
  styleUrls: ['./loader.component.scss'],
})
export class LoaderComponent implements OnInit, OnDestroy {
  subscription?: Subscription
  showLoader = true
  loadingStep?: string
  loadingStepParams?: Record<string, any>

  constructor(
    private loaderService: LoaderService,
    private stateService: StateService
  ) {
    // do nothing
  }

  ngOnInit(): void {
    this.subscription = combineLatest([
      this.stateService.error$,
      this.stateService.isLoading$,
      this.loaderService.step$,
    ]).subscribe(([hasError, isLoading, loadingStep]) => {
      this.showLoader = !hasError && isLoading
      if (loadingStep && (!loadingStep.debugOnly || environment.enableDebug)) {
        this.loadingStep = loadingStep.label
        this.loadingStepParams = loadingStep.params
      } else {
        this.loadingStep = undefined
        this.loadingStepParams = undefined
      }
    })
  }

  ngOnDestroy(): void {
    this.subscription?.unsubscribe()
  }
}
